import { Injectable, signal } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MpsLoaderService {
  private apiCount = 0;
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoadingSubject.asObservable();
  private displayLoader = signal<boolean>(true);
  private calls: number[] = [];

  showLoader(id: number) {
    if (this.displayLoader()) {
      if (this.apiCount === 0) {
        this.isLoadingSubject.next(true);
      }
      this.apiCount++;
      this.calls.push(id);
    }
  }

  hideLoader(id: number) {
    if (this.displayLoader() || this.calls.includes(id)) {
      this.apiCount--;
      if (this.apiCount === 0) {
        this.isLoadingSubject.next(false);
      }
      this.calls = this.calls.filter((callId) => callId !== id);
    }
  }

  // Be careful when using this method and ensure to call enableAutoLoader after the response
  // is received, otherwise you could end up with an invalid value for _apiCount
  disableAutoLoader() {
    this.displayLoader.set(false);
  }

  enableAutoLoader() {
    this.displayLoader.set(true);
  }

  generateRandomId(): number {
    let id = Math.random() * 1000000000;
    while (this.calls.includes(id)) {
      id = Math.random() * 1000000000;
    }

    return id;
  }
}
